import SimpleBar from "simplebar-react";
import { styled } from "@mui/material/styles";
import "simplebar-react/dist/simplebar.min.css";

export const Scrollbar = styled(SimpleBar)``;
